import en from "./en";
import it from "./it";

export { defaultLang } from "./general";
export type { Lang } from "./general";

const locals = { it, en };
export default locals;
